module.exports = __webpack_public_path__ + "img/location.7f806c4a.svg";